import { RoleService } from "@js/services/RoleService";
import { ODataHelper } from "@js/helpers/ODataHelper";

import {
  ApplicationUserCrudClient,
  CaseLenderStateEnum,
  CaseStatusEnum,
  DealClient,
  DealLender,
  DealLenderClient,
  DealLenderCrudClient,
  DealSummaryDTO,
  LenderClient,
  Organisation,
  OrganisationClient,
  ProductFamilyEnum,
  ProductTypeEnum,
  SwaggerException,
  UserClient,
} from "@src/apis/ModularClient";
import DealHelper from "@js/helpers/DealHelper";
import { UserService } from "@js/services/UserService";
import { CaseService } from "@js/services/CaseService";
import CaseLenderHelper from "@js/helpers/CaseLenderService";
import { ErrorCodes } from "@js/errorCode";

export class DealLenderController {
  static $inject = [
    "$routeParams",
    "$location",
    "RoleService",
    "OrganisationClient",
    "DealLenderClient",
    "LenderClient",
    "DealClient",
    "$sce",
    "UserService",
    "UserClient",
    "CaseService",
    "DealLenderCrudClient",
    "ApplicationUserCrudClient",
    "ODataHelper",
  ];

  //To save url for Lender Logo Image
  lenderLogos: string[] = [];
  //To save the Lender Id and request Lender URL
  lenderId: number[] = [];
  // Controls showing the data loading "spinner"
  dataLoading: boolean = false;
  //Show lender names or Lender Generic Name
  showLenders: boolean = false;

  currentDeal: DealSummaryDTO;
  caseLenders: DealLender[];
  // The lender the user has clicked apply/heads of terms/feedback for
  selectedCaseLender: DealLender;
  // Controls showing the Application Terms and Conditions modal
  showApplyTsAndCs: boolean = false;
  // Controls showing the Preferred Lenders modal
  showPreferredPackagers: boolean = false;
  // Controls showing the application confirmation message
  showApplicationConfirmation: boolean = false;
  // Show the feedback modal
  showFeedbackModal: boolean = false;
  // Show the Information modal
  showInformationMessage: boolean = false;
  // show the button to confirm deleting the case lender
  showConfirmDeleteButton: boolean = false;
  // case to remove
  dealLender: DealLender;
  // indicates whether a bid has been accepted on the case
  hasBidAccepted: boolean = false;

  // Message to be displayed in the message modal
  messageContent: string;

  showProceedModal: boolean = false;

  IsSupplimentInfoFilled: boolean = false;

  currentLenderPreferredBrokers: Organisation[];
  currentLenderPreferredPackagersText: string;
  hasLenderPreferredBrokers: boolean = false;
  isPreferredBrokerBrickflow: boolean = false;
  emailCache = {};

  //Export Modal
  selectedLenders: { [lenderId: number]: boolean } = {};
  showExport: boolean = false;
  showExportButton: boolean = false;
  seeLenderNames: boolean = false;
  showLenderNames: boolean = true;

  isBridging: boolean = true;

  portalLinks: {} = {};

  isDeallockerIntegrationEnabled: boolean = false;
  showDeallockerModal: boolean = false;
  isDeallockerTermsAccepted: boolean = false;
  isSubmittingToDeallocker: boolean = false;
  deallockerTabSelected: number = 1;
  hasEnterpriseLicense: boolean = false;

  isConnectMember: boolean = false;

  constructor(
    private $routeParams: ng.route.IRouteParamsService,
    private $location: ng.ILocationService,
    private roleService: RoleService,
    private organisationClient: OrganisationClient,
    private dealLenderClient: DealLenderClient,
    private lenderClient: LenderClient,
    private dealClient: DealClient,
    private $sce: ng.ISCEService,
    private userService: UserService,
    private userClient: UserClient,
    private caseService: CaseService,
    private dealLenderCrudClient: DealLenderCrudClient,
    private applicationUserCrudClient: ApplicationUserCrudClient,
    private odataHelper: ODataHelper,
  ) {
    this.userClient.hasCurrentUserGotEnterpriseLicense().then((response) => {
      this.hasEnterpriseLicense = response;
    });

    if (this.$routeParams.dealId) {
      this.dataLoading = true;

      this.organisationClient.getOrganisationProductAccess().then((response) => {
        this.isDeallockerIntegrationEnabled = response.isDeallockerIntegrationEnabled;
        this.isConnectMember = response.isConnectMember;
      });

      this.dealClient
        .getDealSummary(this.$routeParams.dealId)
        .then((response) => {
          this.currentDeal = response;

          this.lenderDisplayName();

          this.userService.GetDefaultBrokerOrganisation().then((result) => {
            this.seeLenderNames = result?.showLenderNames;
            this.dealLenderClient
              .fetchByDealId(this.$routeParams.dealId, this.seeLenderNames)
              .then((response) => {
                this.caseLenders = response.filter((dl) => dl.isPrimaryProduct);

                for (var i = 0; i < this.caseLenders.length; i++) {
                  this.lenderId[i] = this.caseLenders[i].lenderId;
                  this.toggleLender(this.caseLenders[i]);
                }
                /* this.getAllLenderLogos(this.lenderId);*/

                var bidAccepted = this.caseLenders.find((x) => x.isBidAccepted == true);

                if (bidAccepted) {
                  this.hasBidAccepted = true;
                }
                this.dipRecieved();
              })
              .then(() => {
                this.getLenderPortalLinks();
              });
          });

          this.IsSupplimentInfoFilled = caseService.getIsSupplimentInfoFilled();
        })
        .catch((error: SwaggerException) => {
          if (error.status == ErrorCodes.NotFound) {
            this.messageContent = error.response;
            this.showInformationMessage = true;
          }
        })
        .finally(() => {
          this.dataLoading = false;
        });
    }
  }

  ////Get URL for the specific lender
  //getLenderLogos(index: number) {
  //    return this.lenderLogos[index];
  //}

  //// Get all URL for all Lender result
  //getAllLenderLogos(lenderId: number[]) {
  //    this.lenderClient.getAllLenderLogos(lenderId).then(result => {
  //        this.lenderLogos = result;

  //    })
  //}

  /** Redirects to the case dashboard */
  goToCaseDashboard() {
    DealHelper.goToCaseDashboard(this.currentDeal.id, this.currentDeal.productFamily, this.$location);
  }

  /** Redirects to the user dashboard */
  goToUserDashboard() {
    this.userService.clearSelectedNavMenuAndFilterStorageData();
    this.$location.path("/userdashboard");
  }

  lenderDisplayName() {
    this.organisationClient.showLenderNamesAndLogos(this.$routeParams.dealId, true).then((result) => {
      this.showLenders = result;
    });
  }

  /**Process the Submit Terms and Conditions button being clicked */
  submitTsAndCsClicked() {
    this.showApplyTsAndCs = false;
    this.dealLenderCrudClient
      .patch({
        id: this.selectedCaseLender.id,
        isBidAccepted: true,
      })
      .then((response) => {
        this.selectedCaseLender.isBidAccepted = response.isBidAccepted;
        this.hasBidAccepted = response.isBidAccepted;

        return this.dealLenderClient.applyToLender(this.selectedCaseLender.dealId, this.selectedCaseLender.id);
      })
      .then((response) => {
        this.selectedCaseLender.status = response.caseLenderState;
        this.caseLenders = this.caseLenders.map((cl) =>
          cl.id !== this.selectedCaseLender.id ? cl : this.selectedCaseLender,
        );
      })
      .finally(() => {
        this.dealLenderClient.sendProceedDipEmails(this.currentDeal.id, this.selectedCaseLender.id);
        this.messageContent = "Thank you for submitting an application with this lender.";
        if (this.hasLenderPreferredBrokers && !this.currentDeal.isConnectUser && !this.isConnectMember) {
          this.showPreferredPackagers = true;
        } else {
          this.showInformationMessage = true;
        }
      });
  }

  /**
   * Process the Apply button being clicked
   */
  submit(lender) {
    this.selectedCaseLender = lender;

    this.lenderClient
      .getSelectedLenderPreferredOrgs(this.selectedCaseLender.lenderId)
      .then((response) => {
        this.currentLenderPreferredBrokers = response;

        return this.userService.getBrokerOrganisationId();
      })
      .then((response) => {
        //checks if broker that applies is not part of the preferred brokers list

        this.hasLenderPreferredBrokers =
          this.currentLenderPreferredBrokers != null &&
          this.currentLenderPreferredBrokers.length > 0 &&
          !this.currentLenderPreferredBrokers.some((org) => org.id === response);

        if (this.hasLenderPreferredBrokers) {
          this.currentLenderPreferredBrokers.forEach((org) => {
            this.getBrokerAdminEmail(org);
          });
        }

        // Determine if any of the preferred brokers are IsBrickflow = true
        this.isPreferredBrokerBrickflow = this.currentLenderPreferredBrokers.some((org) => org.isBrickflow);

        return this.lenderClient.getLenderPreferredPackagersText(this.selectedCaseLender.lenderId);
      })
      .then((response) => {
        this.currentLenderPreferredPackagersText = response;
      })
      .finally(() => {
        this.submitTsAndCsClicked();
      });
  }

  /**
   * Process the Apply button being clicked
   * @param currentCaseLender
   */
  applyClicked(selectedCaseLender: DealLender) {
    this.selectedCaseLender = selectedCaseLender;

    // Show the Terms and Conditions modal
    this.showApplyTsAndCs = true;
  }
  /**
   * Process the cancel Application button being clicked
   * @param currentCaseLender
   */
  cancelTerms(selectedCaseLender: DealLender) {
    this.dealLenderClient
      .getSelectedCaseLender(selectedCaseLender.id)
      .then((response) => {
        this.selectedCaseLender = response;
      })
      .then(() => {
        if (this.selectedCaseLender.status == CaseLenderStateEnum.Applied) {
          this.dealLenderCrudClient
            .patch({
              id: this.selectedCaseLender.id,
              isBidAccepted: false,
            })
            .then((response) => {
              this.selectedCaseLender.isBidAccepted = response.isBidAccepted;
              this.hasBidAccepted = response.isBidAccepted;

              return this.dealLenderClient.cancelApplication(
                this.selectedCaseLender.dealId,
                this.selectedCaseLender.id,
              );
            })
            .then((response) => {
              this.selectedCaseLender.status = response.caseLenderState;
              this.caseLenders = this.caseLenders.map((cl) =>
                cl.id !== this.selectedCaseLender.id ? cl : this.selectedCaseLender,
              );
            })
            .finally(() => {
              this.messageContent = "Application with this lender has been cancelled.";
              this.showInformationMessage = true;
            });
        } else {
          this.messageContent = "There was a problem with cancelling this application. Please refresh and try again.";
          this.showInformationMessage = true;
        }
      });

    //this.showProceedModal = true;
  }

  getStatusText(selectedCaseLender: DealLender): string {
    var statusText = "";

    if (this.roleService.IsLender) {
      statusText = CaseLenderHelper.getStatusTextForLender(selectedCaseLender.status, selectedCaseLender.isBidAccepted);
    } else {
      switch (selectedCaseLender.status) {
        case CaseLenderStateEnum.Offered: {
          if (this.hasBidAccepted) {
            statusText = selectedCaseLender.isBidAccepted
              ? "DIP received and accepted"
              : "DIP received but applying to another lender";
          } else {
            statusText = "DIP received";
          }
          break;
        }
        case CaseLenderStateEnum.Received: {
          statusText = "Awaiting DIP";
          if (this.hasBidAccepted) {
            statusText = "Awaiting DIP but applying to another lender";
          } else {
            statusText = "Awaiting DIP";
          }
          break;
        }
        case CaseLenderStateEnum.Cancelled: {
          if (this.hasBidAccepted) {
            statusText = "Application cancelled but applying to another lender";
          } else {
            statusText = "Application cancelled";
          }
          break;
        }
        case CaseLenderStateEnum.SentToPackager: {
          if (this.currentDeal.isConnectUser) {
            statusText = "Case to Review";
          } else {
            statusText = "Sent to Packager";
          }
          break;
        }
      }
    }

    return statusText;
  }

  editApplicationDetails() {
    this.$location.path("/dealapplicationdetails/" + this.currentDeal.id);
  }

  deleteButton(dealLender: DealLender) {
    this.showConfirmDeleteButton = true;
    this.showInformationMessage = true;
    this.messageContent = "Are you sure you want to remove " + dealLender.lenderName + "?";
    this.dealLender = dealLender;
  }

  delete() {
    this.dealLenderClient
      .markAsDeleted(this.dealLender.id)
      .then((result) => {
        this.caseLenders = this.caseLenders.filter((x) => x.id != this.dealLender.id);
      })
      .finally(() => {
        this.showInformationMessage = false;
        delete this.dealLender;
        this.showConfirmDeleteButton = false;
      });
  }

  /**
   * Determines whether to show the Shortlist More Lenders button.
   * Should be shown if there are less than 3 "active" shortlisted lenders i.e. haven't rejected/withdrawn
   * and no DIP is accepted
   * */
  showShortlistMoreLendersButton(): boolean {
    let showButton: boolean = false;
    if (this.caseLenders) {
      const activeShortlistCount = this.caseLenders.filter(
        (lender) => lender.status != CaseLenderStateEnum.Withdrawn && lender.status != CaseLenderStateEnum.Rejected,
      ).length;

      showButton = activeShortlistCount < DealHelper.noOfShortlistAllowed ? true : false;
    }

    //Hide button if DIP accepted
    if (this.hasBidAccepted) {
      showButton = false;
    }

    if (
      this.currentDeal != null &&
      this.currentDeal.isReferredToConnect &&
      !this.currentDeal.isConnectUser &&
      (this.currentDeal.status == CaseStatusEnum.SentToPackager || this.currentDeal.status == CaseStatusEnum.Applied)
    ) {
      showButton = false;
    }

    if (this.currentDeal != null && this.currentDeal.isReferredToConnect && this.currentDeal.isConnectUser) {
      showButton = false;
    }

    return showButton;
  }

  shortlistMoreLenders() {
    if (this.currentDeal.productFamily == ProductFamilyEnum.Commercial) {
      this.$location.path("/commercialshortlistmore/" + this.currentDeal.id);
    } else if (this.currentDeal.productFamily == ProductFamilyEnum.Bridging) {
      this.$location.path("/bridgingshortlistmore/" + this.currentDeal.id);
    } else if (this.currentDeal.productFamily == ProductFamilyEnum.Development) {
      this.$location.path("/devfinanceshortlistmore/" + this.currentDeal.id);
    }
  }

  toggleLender(lender: DealLender) {
    this.selectedLenders[lender.id] = !this.selectedLenders[lender.id];
  }

  stateFilter(lender: DealLender) {
    return !lender.isDeleted && (lender.status === 2 || lender.status === 10 || lender.status === 5);
  }

  showAndHideExport() {
    this.showExport = !this.showExport;
  }

  getSelectedCaseLenders() {
    const selectedCaseLenders = this.caseLenders.filter((lender) => this.selectedLenders[lender.id]);
    return selectedCaseLenders;
  }

  areLendersSelected() {
    for (var lenderId in this.selectedLenders) {
      if (this.selectedLenders[lenderId]) {
        return true;
      }
    }
    return false;
  }

  dipRecieved() {
    this.showExportButton = this.caseLenders.some(
      (lender) => lender.status === 2 || lender.status === 10 || lender.status === 5,
    );
  }

  /** Process the Heads of Terms button being clicked */
  headsOfTermsClicked(selectedCaseLender: DealLender, index) {
    this.selectedCaseLender = selectedCaseLender;
    if (this.currentDeal.productFamily == ProductFamilyEnum.Commercial) {
      this.$location.path("/commercialheadsofterm/" + this.currentDeal.id + "/" + this.selectedCaseLender.id);
    } else if (this.currentDeal.productType == ProductTypeEnum.Development) {
      this.$location.path("/devfinanceheadsofterm/" + this.currentDeal.id + "/" + this.selectedCaseLender.id);
    } else {
      this.$location.path("/bridgingheadsofterm/" + this.currentDeal.id + "/" + this.selectedCaseLender.id);
    }
  }

  trustedHtml(plainText) {
    return this.$sce.trustAsHtml(plainText);
  }

  getBrokerAdminEmail(org: Organisation) {
    if (this.emailCache && this.emailCache[org.id]) {
      return;
    }

    if (!org.preferredPackagerEmail) {
      this.odataHelper
        .getOne(this.applicationUserCrudClient, {
          filter: {
            and: [{ organisationId: { eq: org.id } }, { isOrganisationAdmin: { eq: true } }],
          },
          select: {
            email: true,
          },
        })
        .then((res) => {
          this.emailCache[org.id] = res;
        });
    } else {
      this.emailCache[org.id] = org.preferredPackagerEmail;
    }
  }

  getLenderPortalLinks() {
    const lenderIds = this.caseLenders.filter((dl) => dl.hasAppliedInLenderPortal).map((dl) => dl.lenderId);

    this.lenderClient
      .getLenderPortalLinks(lenderIds)
      .then((links) => {
        this.portalLinks = links;
      })
      .catch((error) => {
        this.portalLinks = null;
      });
  }

  openPortalLink(portalLink: string) {
    if (!/^https?:\/\//i.test(portalLink)) {
      portalLink = "http://" + portalLink;
    }
    window.open(portalLink, "_blank");
  }

  submitToDealocker() {
    this.isSubmittingToDeallocker = true;
    //TODO call deallocker API end point
    this.dealLenderClient
      .submitToDealLocker(this.dealLender.id)
      .then((response) => {
        return response;
      })
      .then((response) => {
        if (response) {
          return this.dealLenderClient.getSelectedCaseLender(this.dealLender.id).then((caseLender) => {
            if (caseLender && caseLender.id) {
              this.caseLenders = [
                ...this.caseLenders.map((lender) => (lender.id === caseLender.id ? caseLender : lender)),
              ];
            }
            this.showInformationMessage = true;
            this.messageContent =
              "Your case information has been sent to Deallocker. They'll confirm receipt via email.";
            return caseLender;
          });
        }
      })
      .catch(() => {
        // TODO do something if it fails?
      })
      .finally(() => {
        this.showDeallockerModal = false;
        this.isSubmittingToDeallocker = false;
        this.isDeallockerTermsAccepted = false;
        this.dealLender = null;
      });
  }

  sendDealToPackagerForReview(selectedCaseLender: DealLender) {
    this.selectedCaseLender = selectedCaseLender;

    this.dealLenderClient
      .sendDealToPackagerForReview(this.selectedCaseLender.dealId, this.selectedCaseLender.id)
      .then((response) => {
        this.selectedCaseLender.status = response.caseLenderState;
        this.currentDeal.status = response.dealStatus;
        this.currentDeal.isReferredToConnect = response.isReferredToConnect;
        this.caseLenders = this.caseLenders.map((cl) =>
          cl.id !== this.selectedCaseLender.id ? cl : this.selectedCaseLender,
        );
      })
      .catch(() => {
        this.messageContent = "Error while sending case information to Connect Packager, please try later.";
        this.showInformationMessage = true;
      })
      .finally(() => {
        this.messageContent = "Your case information has been sent to Connect Packager";
        this.showInformationMessage = true;
      });
  }

  showApplyButton(lender) {
    if (
      !(lender.isConnectReferralOnly && this.isConnectMember) &&
      !(
        this.isConnectMember &&
        this.currentDeal.isReferredToConnect &&
        (this.currentDeal.status == CaseStatusEnum.Applied || this.currentDeal.status == CaseStatusEnum.SentToPackager)
      ) &&
      (this.hasBidAccepted == false || this.hasBidAccepted == null) &&
      (lender.status == CaseLenderStateEnum.Offered ||
        lender.status == CaseLenderStateEnum.Cancelled ||
        lender.status == CaseLenderStateEnum.SentToPackager)
    ) {
      return true;
    }

    return false;
  }

  showCancelApplicationButton(lender) {
    if (
      !(lender.isConnectReferralOnly && this.isConnectMember) &&
      !(
        this.isConnectMember &&
        this.currentDeal.isReferredToConnect &&
        (this.currentDeal.status == CaseStatusEnum.Applied || this.currentDeal.status == CaseStatusEnum.SentToPackager)
      ) &&
      lender.isBidAccepted == true &&
      lender.status == CaseLenderStateEnum.Applied
    ) {
      return true;
    }

    return false;
  }

  showSendToPackagerButton(lender) {
    if (
      lender.isConnectReferralOnly &&
      this.isConnectMember &&
      (this.hasBidAccepted == false || this.hasBidAccepted == null) &&
      (lender.status == CaseLenderStateEnum.Offered || lender.status == CaseLenderStateEnum.Cancelled)
    ) {
      return true;
    }

    return false;
  }
}
